import React, { FC, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { CellWithCurrency } from '../table/CellWithCurrency';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';
import { AdjustmentModalContent } from './AdjustmentModalContent';
import { IAdjustmentModalStateProps } from '../../views/batches/BatchesListPage';
import { setAdjustment, setReserve } from '../../store/order/actions/batches';
import { successAlert } from '../ToastMessage';
import { fetchUnpostedBatchData } from '../../store/payments/actions/batches';
import { useLocation } from 'react-router';
import { parseSearchParams } from '../../utils/utilities';
import { IBatchesFiltersParams } from './BatchesFilterSection';
import { usePaymentContext } from '../../store/payments/payments-context';

interface Props {
	value: number;
	currencySymbol: string;
	currencyCode: string;
	paymentId: string;
	reserve?: boolean;
}

export const AdjustmentModalComponent: FC<Props> = (props) => {
	const { value, currencyCode, currencySymbol, paymentId, reserve } = props;

	const { search } = useLocation();

	const { dispatch } = usePaymentContext();

	const filtersFromUrl: IBatchesFiltersParams = parseSearchParams(search) || {};

	const [modalState, setModalState] = useState<IModalWindow>({
		isOpen: false
	});
	const [adjustmentModalState, setIsAdjustmentModalState] = useState<IAdjustmentModalStateProps>({
		isOpen: false,
		paymentId: '',
	});

	const handleFormSubmit = async (body): Promise<void> => {
		try {
			if (reserve) {
				delete body.paymentType;
				await setReserve(adjustmentModalState.paymentId, body);
			} else {
				await setAdjustment(adjustmentModalState.paymentId, body);
			}
			successAlert({
				title: 'Adjustment was successfully added'
			});

			await fetchUnpostedBatchData({ dispatch, params: filtersFromUrl });

		} catch (e) {
			console.log('setAdjustment', e?.response);
		}
	};

	return (
		<>
			<div
				className="d-flex align-items-start cursor-pointer fc-text-overflow"
				onClick={(): void => setIsAdjustmentModalState({ isOpen: true, paymentId })}
			>
				<FontAwesomeIcon icon={faPen} className="w-10px text-danger mt-1 me-2"/>
				<CellWithCurrency
					value={value}
					currencySymbol={currencySymbol}
					currencyCode={currencyCode}
					isPositive={value >= 0 && !reserve}
				/>

			</div>
			<ModalWindow
				{...modalState}
				onClose={(): void => setModalState(prev => ({ ...prev, isOpen: false }))}
			/>
			<ModalWindow
				isOpen={adjustmentModalState.isOpen}
				onClose={(): void => setIsAdjustmentModalState({ isOpen: false, paymentId: '' })}
				modalTitle={reserve ? 'Reserve' : 'Adjustment'}
				contentClassName='d-block'
				minHeight={185}
				content={
					<AdjustmentModalContent
						closeModal={(): void => setIsAdjustmentModalState({ isOpen: false, paymentId: '' })}
						onFormSubmit={handleFormSubmit}
						reserve={reserve}
					/>
				}
			/>
		</>
	);
};
